import { ConfirmModal } from '@vrplatform/components';
import { captureSentryError } from '@vrplatform/data';
import { showWarnNotification } from '@vrplatform/theme';
import { useReservationAdjustmentMutation } from '../_hooks';

type Props = {
  reservationLine: {
    id: string;
    type: 'adjustment' | 'financial';
  } | null;
  reservationId: string;
  closeModal: () => void;
};

export const ReservationFinancialsDeleteModal = ({
  reservationLine,
  closeModal,
  reservationId,
}: Props) => {
  const opened = !!reservationLine;

  const { submit, loading } = useReservationAdjustmentMutation(
    reservationId,
    closeModal
  );

  return (
    <ConfirmModal
      type="delete"
      opened={opened}
      closeModal={closeModal}
      loading={loading}
      title={
        reservationLine?.type === 'adjustment'
          ? 'Are you sure you want to delete the adjustment?'
          : 'Are you sure you want to delete the financial?'
      }
      subtitle="This will delete any related journal entries."
      onSubmit={async () => {
        if (!reservationLine) {
          captureSentryError('Missing reservation line to delete');
          showWarnNotification({
            title: 'Missing reservation line',
            message: 'Please reach out to support if the issue persists.',
          });
          return;
        }

        return await submit(reservationLine.type, {
          type: 'remove',
          data: {
            id: reservationLine.id,
          },
        });
      }}
    />
  );
};
